var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProjects = function SvgIconProjects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -18.15,
    y1: 424.93,
    x2: 384.02,
    y2: 36.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -106.47,
    y1: 333.44,
    x2: 295.71,
    y2: -54.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -41.65,
    y1: 400.59,
    x2: 360.52,
    y2: 12.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -41.65,
    y1: 400.59,
    x2: 360.52,
    y2: 12.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -4.51,
    y1: 439.06,
    x2: 397.66,
    y2: 50.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 39.13,
    y1: 484.28,
    x2: 441.3,
    y2: 96.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 43.95,
    y1: 489.27,
    x2: 446.12,
    y2: 101.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 27.18,
    y1: 471.9,
    x2: 429.36,
    y2: 83.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 70.83,
    y1: 517.12,
    x2: 473,
    y2: 128.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 75.64,
    y1: 522.11,
    x2: 477.82,
    y2: 133.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 9.76,
    y1: 453.85,
    x2: 411.93,
    y2: 65.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 84.61,
    y1: 531.4,
    x2: 486.79,
    y2: 143.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 155.16,
    y1: 604.48,
    x2: 557.33,
    y2: 216.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 117.62,
    y1: 565.59,
    x2: 519.79,
    y2: 177.4,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M113.68,488.19H17.8c-3.31,0-6.01-2.7-6.01-6.01V205.31c0-3.25-2.64-5.89-5.89-5.89s-5.89,2.64-5.89,5.89v276.87c0,9.81,7.98,17.8,17.8,17.8h95.88c3.25,0,5.89-2.64,5.89-5.89s-2.64-5.89-5.89-5.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.89,176.73c3.26,0,5.89-2.64,5.89-5.89v-91.51c0-3.31,2.7-6.01,6.01-6.01h307.47c3.25,0,5.89-2.64,5.89-5.89s-2.64-5.89-5.89-5.89H17.8c-9.81,0-17.8,7.98-17.8,17.8v91.51c0,3.25,2.64,5.89,5.89,5.89Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M147.73,175.58c-23.27,0-42.21,18.93-42.21,42.21s18.93,42.21,42.21,42.21,42.21-18.93,42.21-42.21-18.93-42.21-42.21-42.21ZM147.73,248.21c-16.77,0-30.42-13.65-30.42-30.42s13.65-30.42,30.42-30.42,30.42,13.65,30.42,30.42-13.65,30.42-30.42,30.42Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M261.69,166.15l-12.26-21.24c-3.72-6.45-11.47-9.18-18.42-6.5l-28.06,10.84c-7.11-5.75-14.98-10.3-23.47-13.58l-4.64-29.7c-1.15-7.36-7.39-12.7-14.84-12.7h-24.53c-7.45,0-13.69,5.34-14.84,12.7l-4.64,29.7c-8.49,3.28-16.36,7.83-23.47,13.58l-28.06-10.84c-6.95-2.68-14.69.05-18.42,6.5l-12.27,21.24c-3.72,6.45-2.22,14.53,3.58,19.2l23.41,18.88c-.69,4.48-1.04,9.02-1.04,13.56s.35,9.08,1.04,13.56l-23.41,18.88c-5.8,4.68-7.3,12.75-3.58,19.2l12.26,21.24c3.72,6.45,11.47,9.19,18.42,6.5l28.06-10.84c7.11,5.74,14.98,10.3,23.47,13.58l4.64,29.7c1.15,7.36,7.39,12.7,14.84,12.7h24.53c7.45,0,13.69-5.34,14.84-12.7l4.64-29.7c8.49-3.28,16.36-7.83,23.47-13.58l28.06,10.84c6.95,2.69,14.69-.05,18.42-6.5l12.26-21.24c3.72-6.45,2.22-14.52-3.58-19.2t0,0l-23.41-18.88c.69-4.48,1.04-9.03,1.04-13.56s-.35-9.08-1.04-13.56l23.41-18.88c5.8-4.68,7.3-12.75,3.58-19.2ZM250.71,176.18l-26.12,21.06c-1.7,1.37-2.51,3.58-2.08,5.73.96,4.86,1.44,9.85,1.44,14.82s-.49,9.95-1.45,14.82c-.42,2.15.38,4.35,2.08,5.73l26.12,21.06c1.25,1.01,1.57,2.74.77,4.13l-12.26,21.24c-.8,1.39-2.47,1.98-3.96,1.4l-31.31-12.09c-2.04-.79-4.36-.38-6.01,1.06-7.56,6.62-16.19,11.61-25.65,14.83-2.07.71-3.59,2.5-3.93,4.67l-5.18,33.14c-.25,1.58-1.59,2.73-3.19,2.73h-24.53c-1.6,0-2.94-1.15-3.19-2.73l-5.18-33.14c-.34-2.17-1.85-3.96-3.93-4.67-9.46-3.22-18.09-8.21-25.65-14.83-1.09-.96-2.48-1.46-3.89-1.46-.71,0-1.43.13-2.12.4l-31.31,12.09c-1.49.58-3.16-.01-3.96-1.4l-12.26-21.24c-.8-1.39-.48-3.12.77-4.13l26.12-21.06c1.7-1.37,2.51-3.58,2.08-5.73-.96-4.86-1.44-9.85-1.44-14.82s.49-9.96,1.44-14.82c.42-2.15-.38-4.35-2.08-5.73l-26.12-21.06c-1.25-1.01-1.57-2.74-.77-4.13l12.27-21.24c.8-1.39,2.47-1.98,3.96-1.4l31.31,12.09c2.04.79,4.36.38,6.01-1.07,7.56-6.62,16.19-11.61,25.65-14.83,2.07-.71,3.59-2.5,3.93-4.67l5.18-33.14c.25-1.58,1.59-2.73,3.19-2.73h24.53c1.6,0,2.94,1.15,3.19,2.73l5.18,33.14c.34,2.17,1.85,3.96,3.93,4.67,9.46,3.22,18.09,8.21,25.65,14.83,1.65,1.44,3.96,1.85,6.01,1.06l31.31-12.09c1.49-.58,3.16.01,3.96,1.4l12.26,21.24c.8,1.39.48,3.12-.77,4.13Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M75.3,375.1c0-7.63-6.21-13.83-13.83-13.83h-15.88c-7.63,0-13.83,6.2-13.83,13.83v15.88c0,7.63,6.21,13.83,13.83,13.83h15.88c7.63,0,13.83-6.2,13.83-13.83v-15.88ZM63.51,390.98c0,1.13-.92,2.05-2.05,2.05h-15.88c-1.13,0-2.04-.92-2.04-2.04v-15.88c0-1.13.92-2.04,2.04-2.04h15.88c1.13,0,2.04.92,2.04,2.04v15.88Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M219.76,361.27h-118.61c-3.25,0-5.89,2.64-5.89,5.89s2.64,5.89,5.89,5.89h118.61c3.25,0,5.89-2.64,5.89-5.89s-2.64-5.89-5.89-5.89Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M101.16,404.81h72.8c3.25,0,5.89-2.64,5.89-5.89s-2.64-5.89-5.89-5.89h-72.8c-3.25,0-5.89,2.64-5.89,5.89s2.64,5.89,5.89,5.89Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M45.59,424.7c-7.63,0-13.83,6.2-13.83,13.83v15.88c0,7.63,6.21,13.83,13.83,13.83h15.88c7.63,0,13.83-6.2,13.83-13.83v-15.88c0-7.63-6.21-13.83-13.83-13.83h-15.88ZM63.51,438.54v15.88c0,1.13-.92,2.05-2.05,2.05h-15.88c-1.13,0-2.04-.92-2.04-2.04v-15.88c0-1.13.92-2.04,2.04-2.04h15.88c1.13,0,2.04.92,2.04,2.04Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M225.66,430.6c0-3.25-2.64-5.89-5.89-5.89h-118.61c-3.25,0-5.89,2.64-5.89,5.89s2.64,5.89,5.89,5.89h118.61c3.25,0,5.89-2.64,5.89-5.89Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.16,456.46c-3.25,0-5.89,2.64-5.89,5.89s2.64,5.89,5.89,5.89h72.8c3.25,0,5.89-2.64,5.89-5.89s-2.64-5.89-5.89-5.89h-72.8Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M386.94,111.14c0-9.82-7.99-17.8-17.8-17.8h-67.66c-9.82,0-17.8,7.99-17.8,17.8v39.69c0,9.82,7.99,17.8,17.8,17.8h27.94v34.42l-9.79-9.78c-2.3-2.3-6.03-2.3-8.34,0-2.3,2.3-2.3,6.03,0,8.34l19.84,19.84c.28.28.58.53.91.74.02.01.04.03.06.04.3.2.62.36.96.5.02.01.05.02.08.03.33.13.67.23,1.02.3.02,0,.04,0,.06,0,.35.07.71.1,1.08.1s.73-.04,1.08-.1c.02,0,.04,0,.06,0,.35-.07.7-.17,1.02-.3.03,0,.05-.02.08-.03.34-.14.65-.31.96-.5.02-.01.04-.02.06-.04.33-.22.63-.47.91-.74l19.84-19.84c2.3-2.3,2.3-6.03,0-8.34s-6.03-2.3-8.34,0l-9.78,9.78v-34.42h27.94c9.82,0,17.8-7.99,17.8-17.8v-39.69ZM375.15,150.84c0,3.32-2.7,6.01-6.01,6.01h-67.66c-3.32,0-6.01-2.7-6.01-6.01v-39.69c0-3.32,2.7-6.01,6.01-6.01h67.66c3.32,0,6.01,2.7,6.01,6.01v39.69Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M386.94,260.95c0-9.82-7.99-17.8-17.8-17.8h-67.66c-9.82,0-17.8,7.99-17.8,17.8v39.69c0,9.82,7.99,17.8,17.8,17.8h27.94v34.42l-9.79-9.79c-2.3-2.3-6.03-2.3-8.34,0s-2.3,6.03,0,8.34l19.85,19.85s0,0,0,0c.27.27.58.52.9.74.02.01.05.03.07.04.3.19.62.36.95.5.03.01.05.02.08.03.33.13.67.23,1.02.3.02,0,.04,0,.06,0,.35.07.71.1,1.08.1s.73-.04,1.08-.1c.02,0,.04,0,.06,0,.35-.07.7-.17,1.02-.3.02,0,.05-.02.07-.03.34-.14.66-.31.96-.5.02-.01.04-.02.06-.04.33-.22.64-.47.91-.75l19.84-19.84c2.3-2.3,2.3-6.03,0-8.33-2.3-2.3-6.03-2.3-8.33,0l-9.78,9.78v-34.42h27.94c9.82,0,17.8-7.99,17.8-17.8v-39.69ZM375.15,300.64c0,3.32-2.7,6.01-6.01,6.01h-67.66c-3.32,0-6.01-2.7-6.01-6.01v-39.69c0-3.32,2.7-6.01,6.01-6.01h67.66c3.32,0,6.01,2.7,6.01,6.01v39.69Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.13,392.95h-67.66c-9.82,0-17.8,7.99-17.8,17.8v39.69c0,9.82,7.99,17.8,17.8,17.8h67.66c9.82,0,17.8-7.99,17.8-17.8v-39.69c0-9.82-7.99-17.8-17.8-17.8ZM375.15,450.44c0,3.32-2.7,6.01-6.01,6.01h-67.66c-3.32,0-6.01-2.7-6.01-6.01v-39.69c0-3.32,2.7-6.01,6.01-6.01h67.66c3.32,0,6.01,2.7,6.01,6.01v39.69Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M500,446.47h0c0-.11,0-.22,0-.32V54.37c0-14.4-5.92-28.55-16.25-38.8-10.12-10.05-23.35-15.57-37.29-15.57-.12,0-.25,0-.37,0-10.63.07-20.88,3.26-29.65,9.21-5.97,4.06-9.54,10.79-9.54,18.02v34.29h-47.16c-3.25,0-5.89,2.64-5.89,5.89s2.64,5.89,5.89,5.89h47.16v312.2c0,6.91,3.17,13.25,8.7,17.4,5.54,4.15,12.53,5.43,19.18,3.49,3.78-1.1,7.72-1.66,11.69-1.66,23.01,0,41.74,18.72,41.74,41.74,0,23.01-18.72,41.74-41.74,41.74H148.16c-3.25,0-5.89,2.63-5.89,5.88s2.64,5.89,5.89,5.89h298.31c29.51,0,53.52-24,53.53-53.51,0,0,0,0,0,0h0ZM446.48,392.95c-5.09,0-10.14.72-14.99,2.13-3.06.89-6.27.31-8.81-1.6-2.53-1.9-3.98-4.81-3.98-7.97V67.51s0-.06,0-.09,0-.06,0-.09V27.23c0-3.32,1.64-6.41,4.38-8.27,6.83-4.64,14.82-7.12,23.11-7.18,10.95-.1,21.31,4.24,29.27,12.14,8.11,8.06,12.77,19.15,12.77,30.44v358.63c-9.82-12.22-24.88-20.05-41.74-20.05Z"
  })));
};
export default SvgIconProjects;